const WHOLE_EPS = 1e-6;

export function isWholeGroceryQuantity(n: number): boolean {
  return Number.isFinite(n) && Math.abs(n - Math.round(n)) < WHOLE_EPS;
}

/** Integer step for grocery +/-. Fractional recipe qty snaps toward a whole number first. */
export function stepGroceryQuantity(current: number, delta: 1 | -1): number {
  if (!Number.isFinite(current)) return 1;
  if (isWholeGroceryQuantity(current)) {
    const whole = Math.round(current);
    if (delta === 1) return whole + 1;
    return Math.max(1, whole - 1);
  }
  if (delta === 1) return Math.ceil(current);
  const floored = Math.floor(current);
  // Minus must never increase (e.g. 0.5 should not become 1).
  if (floored < 1) return current;
  return floored;
}

export function formatGroceryQuantity(quantity: number): string {
  if (isWholeGroceryQuantity(quantity)) return String(Math.round(quantity));
  const rounded = Math.round(quantity * 100) / 100;
  return String(rounded);
}
